import { IExportPlugin, PluginType } from '@/version-types';
import { RulerBar } from './ruler-bar';
import rulerState from './states/ruler-state';
import RulerBarView from './views';

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 3,
    name: 'ruler-bar',
    createInstance({ identity }) {
        return [{ key: 'RulerBar', value: new RulerBar(identity) }];
    },
    createState() {
        return [rulerState];
    },
    render() {
        return <RulerBarView />;
    },
    destroy({ getInstance }) {
        getInstance(RulerBar).destroy();
    },
};

export default exportPlugin;
